/* import __COLOCATED_TEMPLATE__ from './mount-mfe.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { mountRootParcel } from 'single-spa';
import 'systemjs';
import * as Sentry from '@sentry/ember';
import environment from '@square/environment-utils/environment';
import { datadogRum } from '@datadog/browser-rum';
let SingleSpaMountMfe = (_dec = service('single-spa/manifest'), _class = class SingleSpaMountMfe extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "parcel", void 0);
    _defineProperty(this, "module", void 0);
    _defineProperty(this, "domElement", void 0);
    _initializerDefineProperty(this, "singleSpaManifest", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _initializerDefineProperty(this, "queryClient", _descriptor3, this);
    _initializerDefineProperty(this, "navigationShim", _descriptor4, this);
    _initializerDefineProperty(this, "isMounting", _descriptor5, this);
    _initializerDefineProperty(this, "mountFailure", _descriptor6, this);
    _initializerDefineProperty(this, "failureMessage", _descriptor7, this);
  }
  get className() {
    const classList = ['disable-all-glass-global-css'];
    if (this.args.className) {
      classList.push(this.args.className);
    }
    return classList.join(' ');
  }
  get requiresNavigation() {
    return this.args.requiresNavigation ?? true;
  }
  get mfeProps() {
    const {
      merchantToken,
      name,
      merchantProfile,
      employmentToken,
      browserLanguage,
      currencyCode,
      personToken,
      countryCode,
      impersonating,
      loggableSessionToken
    } = this.userInfo;
    return {
      merchantToken,
      merchantProfile: {
        name,
        createdTimestamp: merchantProfile?.createdTs
      },
      employmentToken,
      locale: browserLanguage,
      currencyCode,
      personToken,
      countryCode,
      sessionId: loggableSessionToken,
      impersonating,
      queryClient: this.queryClient.instance,
      queryClientV5: this.queryClient.instanceV5,
      ...this.args.customProps
    };
  }
  get parcelProps() {
    if (!this.domElement) {
      throw new Error('Property domElement must be defined in parcelProps');
    }
    return {
      domElement: this.domElement,
      ...this.mfeProps
    };
  }
  async setupApp(domElement) {
    try {
      if (this.requiresNavigation) {
        this.navigationShim.start();
      }
      const app = await this.singleSpaManifest.getManifest(this.args.manifestPath, this.args.mfeName);
      const appSrc = `${app.cdnOrigin}/${app[this.args.bundleName]}`;
      await this.mountApplication(appSrc, domElement);
    } catch (e) {
      this.setMountFailure(e);
    }
  }
  async mountApplication(appSrc, domElement) {
    this.isMounting = true;
    this.module = await this.loadBundle(appSrc);
    this.domElement = domElement;
    if (this.module) {
      const parcelConfig = {
        bootstrap: this.module.bootstrap,
        mount: this.module.mount,
        unmount: this.module.unmount,
        update: this.module.update
      };
      this.parcel = mountRootParcel(parcelConfig, this.parcelProps);
      await this.parcel.mountPromise;
      datadogRum.setViewContextProperty('reactType', this.args.reactType || 'unknown');
      this.isMounting = false;
      this.args.onMountCompleted?.();
    }
  }
  loadBundle(appSrc) {
    try {
      return System.import(appSrc);
    } catch (e) {
      this.setMountFailure(e);
      throw e;
    }
  }
  teardownApp() {
    if (this.parcel) {
      this.parcel.unmount().catch(e => Sentry.captureException(e));
    }
  }
  updateParcel() {
    if (this.parcel?.update) {
      this.parcel?.update(this.parcelProps);
    }
  }
  setMountFailure(error) {
    this.mountFailure = true;
    if (environment().isDevelopment && !environment().isTesting && error instanceof Error) {
      this.failureMessage = error.message;
    }
    Sentry.captureException(error);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "singleSpaManifest", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "queryClient", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "navigationShim", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isMounting", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "mountFailure", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "failureMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setupApp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupApp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "teardownApp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "teardownApp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateParcel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateParcel"), _class.prototype), _class);
export { SingleSpaMountMfe as default };